import { createSelector } from 'reselect';
import { isDefined } from '@grandvisionhq/utils';
import * as selectors_internal from './selectors.internal.js';
import { getConfigurator as getConfigurator$1, getStepSequence, getCurrentStepNumber, getStepsVisited, getStepsList } from './selectors.internal.js';

const { configuratorIdProp , stateProp , stepNameProp  } = selectors_internal;
const getConfigurator = createSelector(configuratorIdProp, stateProp, (id, s)=>getConfigurator$1(s, {
        id
    })
);
/**
 * Exported selectors to be used in container components
 */ const hasAttemptedNextStep = createSelector(getConfigurator, (c)=>c ? c.stepsAttempted.has(c.currentStep) : false
);
const getCurrentStep = createSelector(getStepSequence, getCurrentStepNumber, configuratorIdProp, stateProp, (stepSequence, currentStep)=>{
    if (!isDefined(stepSequence) || !isDefined(currentStep)) {
        return;
    }
    var _currentStep;
    return {
        name: (_currentStep = stepSequence[currentStep]) !== null && _currentStep !== void 0 ? _currentStep : ''
    };
});
/**
 * Checks the step name against the list of visited steps in the state.
 */ const hasVisitedStep = createSelector(getStepsVisited, configuratorIdProp, stepNameProp, (stepsVisited, id, stepName)=>(stepsVisited || []).includes(stepName)
);
var ref;
const isFooterOpen = createSelector(getConfigurator, (c)=>{
    return (ref = c === null || c === void 0 ? void 0 : c.isFooterOpen) !== null && ref !== void 0 ? ref : false;
});
/**
 * Checks if we're on the last step, taking into consideration any steps that are disabled or to be skipped.
 */ const isLastStep = createSelector(getStepsList, (steps)=>{
    var ref1;
    if (!steps) {
        return false;
    }
    const lastStepIsCurrentStep = (ref1 = steps[steps.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.isCurrent;
    if (!isDefined(lastStepIsCurrentStep)) {
        return false;
    }
    if (lastStepIsCurrentStep) {
        return true;
    }
    // We're not on the last step, so we have to check if all steps following the current steps should be skipped.
    const currentStep = steps.findIndex((s)=>s.isCurrent
    );
    const remainingSteps = steps.slice(currentStep + 1);
    return remainingSteps.every((s)=>s.skip
    );
});
const getFinishCall = createSelector(getConfigurator, (c)=>{
    return c === null || c === void 0 ? void 0 : c.calls.finish;
});

export { getConfigurator, getCurrentStep, getFinishCall, hasAttemptedNextStep, hasVisitedStep, isFooterOpen, isLastStep };
//# sourceMappingURL=selectors.js.map
